<template>
  <v-content>
    <rating-header :ratio="logoSize" />
    <user-name v-if="getUserName" />
    <user-name-create v-if="!getUserName" />
    <rating-items v-if="getUserName" />
  </v-content>
</template>
<script>
import RatingHeader from './../components/rating/RatingHeader'
import RatingItems from './../components/rating/RatingItems'
import UserName from './../components/UserName'
import UserNameCreate from './../components/UserNameCreate'

export default {
  components: {RatingHeader, RatingItems, UserName, UserNameCreate},
  computed: {
    getUserName () {
      return this.$store.getters.raterName
    },
    logoSize () {
      return this.$store.getters.raterName ? 4 : 2
    }
  }
}
</script>
